import React from 'react'

const ReportesVentas = () => {
  return (
    <div>ReportesVentas</div>
  )
}

export default ReportesVentas